var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var ControllerHelper = /** @class */ (function () {
    function ControllerHelper(data, what, save) {
        if (save === void 0) { save = false; }
        this.callList = [];
        this.addCall = this.addCall.bind(this);
        this.thenCall = this.thenCall.bind(this);
        this.execute = this.execute.bind(this);
        this.callList.push(ControllerHelper.createPromise(data, what, save));
    }
    ControllerHelper.addCall = function (data, what, save) {
        if (save === void 0) { save = false; }
        return new ControllerHelper(data, what, save);
    };
    ControllerHelper.singleCall = function (data, what, save) {
        if (save === void 0) { save = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ControllerHelper.createPromise(data, what, save)];
            });
        });
    };
    ControllerHelper.prototype.addCall = function (data, what, save) {
        if (save === void 0) { save = false; }
        this.callList.push(ControllerHelper.createPromise(data, what, save));
        return this;
    };
    ControllerHelper.prototype.thenCall = function (transform, what, save) {
        if (save === void 0) { save = false; }
        if (this.callList.length === 0)
            throw "thenCall must follow another call";
        var pop = this.callList[this.callList.length - 1];
        if (pop) {
            var last_1 = pop;
            var toAdd = new Promise(function (resolveT, rejectT) {
                last_1.then(function (val) {
                    return what(transform(val), (function (ret) {
                        resolveT(ret);
                    }), function (err) {
                        if (save)
                            resolveT(undefined);
                        else
                            rejectT(err);
                    });
                }, function (err) {
                    if (save)
                        resolveT(undefined);
                    else
                        rejectT(err);
                });
            });
            this.callList.push(toAdd);
        }
        return this;
    };
    ControllerHelper.prototype.execute = function () {
        return __awaiter(this, void 0, void 0, function () {
            var toRet;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(this.callList)];
                    case 1:
                        toRet = _a.sent();
                        this.callList = [];
                        return [2 /*return*/, toRet];
                }
            });
        });
    };
    ControllerHelper.promise = function (data, what, save) {
        if (save === void 0) { save = false; }
        return new Promise(function (resolve, reject) {
            what(data, (function (res) { return resolve(res); }), function (err) { return reject(err); });
        });
    };
    ControllerHelper.createPromise = function (data, what, save) {
        return new Promise(function (resolve, reject) {
            what(data, (function (ret) { return resolve(ret); }), function (err) {
                if (save)
                    resolve(undefined);
                else
                    reject(err);
            });
        });
    };
    return ControllerHelper;
}());
export { ControllerHelper };
//# sourceMappingURL=ControllerHelper.js.map